import type { ModifiedComponent } from '@wix/ambassador-devcenter-components-overrides-v1-components-override/types';
import type { AppManifest } from '@wix/cli-app-manifest';
import type { CliErrorCodeType } from '@wix/cli-error';
import { CliError, CliErrorCode } from '@wix/cli-error';
import { isHttpError, isHttpValidationError } from '@wix/cli-http-client';
import { isTrustedInternalErr } from './isTrustedInternalErr.js';

const { AppPermissionDenied } = CliErrorCode;

export function toModifiedComponents(
  components: AppManifest['components']
): ModifiedComponent[] {
  return components.map((comp) => ({
    componentId: comp.compId,
    data: comp.compData,
    name: comp.compName,
    type: comp.compType as string,
  })) as ModifiedComponent[];
}

export function handleReleaseError(
  e: unknown,
  appId: string,
  fallbackCode: CliErrorCodeType
): never {
  if (isHttpError(e)) {
    if (e.response?.status === 403) {
      throw new CliError({
        cause: e,
        code: AppPermissionDenied({ appId }),
      });
    }

    if (e.response?.status === 400 && isHttpValidationError(e)) {
      throw new CliError({
        cause: e,
        code: CliErrorCode.AppReleaseConfigViolations(),
      });
    }
  }

  if (isTrustedInternalErr(e)) {
    throw new CliError({
      cause: e,
      code: CliErrorCode.TrustedAppIsNotMarkedAsInternal(),
    });
  }

  throw new CliError({ cause: e, code: fallbackCode });
}
